import axios, { AxiosResponse } from "axios";

const auditMetaInfo = {
  getAuditRequestMetaInfo: (clubId: number): Promise<AxiosResponse> =>
    axios.get(`/api/v1/audit-metainfo/audit-request/club/${clubId}`),
};

export default auditMetaInfo;
